import React from "react";
import { ChevronDown } from "lucide-react";

interface IconTextBlockProps {
    icon: React.ReactNode;
    title?: string;
    subtitle?: string;
    rightIcon?: boolean;
    layout?: "vertical" | "horizontal";
    className?: string;
    textclass?: string;
    handleButtonClick?: () => void
}

const HeaderButtons: React.FC<IconTextBlockProps> = ({
    icon,
    title,
    subtitle,
    rightIcon = false,
    layout = "vertical",
    className = "",
    textclass = "",
    handleButtonClick
}) => {
    return (
        <div
            className={`flex items-center gap-2 cursor-pointer 
${className} 
h-[40px] px-2 py-0.5 
rounded-md transition 
hover:bg-iconColor hover:border border-iconColor`}
onClick={handleButtonClick}
        >

            {/* LEFT ICON */}
            <div className="shrink-0">{icon}</div>

            {/* TEXT */}
            {layout === "vertical" ? (
                <div className="flex flex-col">
                    {title && (
                        <span className="text-sm text-gray-200">{title}</span>
                    )}
                    {subtitle && (
                        <span className="text-sm font-semibold">{subtitle}</span>
                    )}
                </div>
            ) : (
                <span className={`text-base ${textclass}`}>{title}</span>
            )}

            {/* RIGHT ICON */}
            {rightIcon && (
                <ChevronDown size={16} className="text-gray-200" />
            )}
        </div>
    );
};

export default HeaderButtons;